import React from 'react';
import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter> */}
    <App />
    {/* </BrowserRouter> */}
    
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();














// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import Appbackend from './Appbackend';
// import reportWebVitals from './reportWebVitals';

// const rootElement = document.getElementById('root');

// const isAdminSection =false;

// ReactDOM.render(
//   <React.StrictMode>
//     {isAdminSection ? <Appbackend /> : (
//       <React.Fragment>
//         <App />
//         <Appbackend />
//       </React.Fragment>
//     )}
//   </React.StrictMode>,
//   rootElement
// );

// reportWebVitals();
